import React, { Component } from 'react'
import { Button, Row } from 'react-bootstrap'
import { FaPencilAlt, FaRegWindowClose, FaCheck } from 'react-icons/fa';
import FormTemplate from '../../components/FormTemplate';
import { MODE_VIEW, MODE_EDIT, SUCCESS, NOTIF_SUCCESS, NOTIF_ERROR, RESULT_ANNOUNCEMENT, SAVE, CANCEL, NO, SECONDARY, YES, SUCCESS_BUTTON, PRIMARY, UPDATE_POSTED_RESULT } from '../../../utils/constants';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { EditorState, ContentState } from 'draft-js';
import htmlToDraft from 'html-to-draftjs';
import ConfirmationModal from '../../components/ConfirmationModal';
import { announcementSelectors } from './state';
import { pollOperations } from './state';
import { SideNotification } from '../../../utils/common';
import { MSG_DEFAULT_ERROR, SAVE_CHANGES, MSG_CONFIRM_CHANGES } from '../../../utils/messages';
import { isNullOrUndefined } from 'util';
import debounce from 'lodash.debounce';

class ResultAnnouncementComponent extends Component {

    constructor(props) {
        super(props)
        this.state = {
            resultAnnouncement: false,
            initialValues: null,
            mode: MODE_VIEW,
            editorState: EditorState.createEmpty(),
            previousEditorState: EditorState.createEmpty(),
            showSaveModal: false,
            resultAnnouncementDetails: ''

        }
        this.editorRef = ref => this.domEditor = ref;
        this.announcementForm = null;
        this.resetForm = null;
        this.saveChanges = debounce(this.saveChanges.bind(this), 500);

    }

    componentDidMount() {

        let announcement = isNullOrUndefined(this.props.poll.pollDetails.pollAnnouncementResult) ? '' : this.props.poll.pollDetails.pollAnnouncementResult
        let contentState = null;
        let blocksFromHtml = htmlToDraft(announcement);
        let { contentBlocks, entityMap } = blocksFromHtml;
        contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
        this.setState({
            editorState: EditorState.createWithContent(contentState),
            previousEditorState: EditorState.createWithContent(contentState),
            initialValues: { AnnouncementModel: { 'pollAnnouncementResult' : announcement } }
        })
    }

    updatePostResult = () => {
        this.domEditor.focusEditor();
        this.setState({
            resultAnnouncement: !this.state.resultAnnouncement,
            mode: MODE_EDIT
        })
    }

    cancelPostResult = () => {
        this.form.resetForm(this.state.initialValues);
        this.setState({
            resultAnnouncement: !this.state.resultAnnouncement,
            mode: MODE_VIEW,
            editorState: this.state.previousEditorState
        })
    }

    updateEditorState = (editorState) => {
        this.setState({ editorState : editorState })
    }

    bindSubmitFormik = (submitForm, resetForm) => {
        this.submitForm = submitForm;
        this.resetForm = resetForm;
    };

    updateFormRef = (newForm) => {
        this.form = newForm;
    }

    onSubmitClick = () => {

        this.form.submitForm();
    }

    handleSubmit = (values) => {

        let value = values.AnnouncementModel.pollAnnouncementResult
        let contentState = null;
        let blocksFromHtml = htmlToDraft(value);
        let { contentBlocks, entityMap } = blocksFromHtml;
        contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);

        this.setState({
            editorState: EditorState.createWithContent(contentState),
            previousEditorState: EditorState.createWithContent(contentState),
            showSaveModal: true,
            resultAnnouncementDetails: value
        })


    }

    toggleSave = () => {
        this.setState(prevState => ({ showSaveModal: !prevState.showSaveModal, mode: MODE_EDIT }));
    }

    saveChanges = () => {

        let id = this.props.poll.pollDetails.pollId
        this.props.updatePollAnnouncement(id, this.state.resultAnnouncementDetails)
            .then(result => {
                if (SUCCESS === result.status) {
                    this.setState({ showSaveModal: false, resultAnnouncement: !this.state.resultAnnouncement, mode: MODE_VIEW})
                    SideNotification(NOTIF_SUCCESS, result.message);
                } else {
                    SideNotification(NOTIF_ERROR, result.message);
                }
            })
            .catch(() => SideNotification(NOTIF_ERROR, MSG_DEFAULT_ERROR))
    }


    render() {
        return (
            <div>
                <Row className="result-announcement-row">
                    <span className="result-announcement"><b>{RESULT_ANNOUNCEMENT}</b></span>
                    {this.state.resultAnnouncement ?
                        <div>
                            <Button variant={SUCCESS_BUTTON} onClick={this.onSubmitClick} className="result-announcement-button"><FaCheck /> {SAVE}</Button>
                            <Button variant={SECONDARY} onClick={() => this.cancelPostResult()}><FaRegWindowClose /> {CANCEL}</Button>
                        </div>
                        :
                        <div>
                            <Button variant={PRIMARY} onClick={() => this.updatePostResult()}><FaPencilAlt /> {UPDATE_POSTED_RESULT}</Button>
                        </div>
                    }
                </Row>

                <FormTemplate
                    editMode={false}
                    readOnly={MODE_VIEW === this.state.mode}
                    initialValues={this.state.initialValues}
                    editorState={this.state.editorState}
                    updateEditorState={this.updateEditorState}
                    bindSubmitFormik={this.bindSubmitFormik}
                    formInputs={this.props.announcementForm}
                    validate={announcementSelectors.validateForm}
                    updateFormRef={this.updateFormRef}
                    handleSubmit={this.handleSubmit}
                    editorRef={this.editorRef}
                />
                <hr />

                <ConfirmationModal
                    show={this.state.showSaveModal}
                    toggleModal={this.toggleSave}
                    title={SAVE_CHANGES}
                    message={MSG_CONFIRM_CHANGES}
                    modalButtons={[
                        { label: NO, onClick: this.toggleSave, variant: SECONDARY },
                        { label: YES, onClick: this.saveChanges, variant: SUCCESS_BUTTON }
                    ]}
                />
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        announcementForm: state.polls.announcementForm,
        poll: state.polls.poll,
    };
}

const mapDispatchToProps = (dispatch) => bindActionCreators(
    {
        updatePollAnnouncement: pollOperations.updatePollAnnouncement
    },
    dispatch
);

export default connect(mapStateToProps, mapDispatchToProps)(ResultAnnouncementComponent);